import { type ReactNode } from 'react';

import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { getQueryClient } from './config.js';

/**
 * QueryProvider Props
 */
export interface QueryProviderProps {
  children: ReactNode;
  client?: QueryClient;
  isDevtoolsOpen?: boolean;
}

/**
 * QueryProvider 컴포넌트
 * TanStack Query의 QueryClientProvider를 래핑
 * client를 제공하지 않으면 기본 싱글톤 인스턴스 사용
 */
export const QueryProvider = ({ children, client }: QueryProviderProps) => {
  const queryClient = client ?? getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={isDevtoolsOpen} /> */}
    </QueryClientProvider>
  );
};
